import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'projectImagePipe'
})

export class ProjectImagePipe implements PipeTransform {
  constructor() {
  }

  transform(projectType: string): any {
    if (projectType === 'ic') {
      return '/assets/img/logo/LOGO-IC.svg';
    } else if (projectType === 'yarn') {
      return '/assets/img/logo/LOGO-YC.svg';
    } else if (projectType === 'act') {
      return '/assets/img/logo/youact.svg';
    } else if (projectType === 'paint') {
      return '/assets/img/logo/LOGO-PR.svg';
    }  else if (projectType === 'space') {
      return '/assets/img/logo/light-CARINGSPACES.svg';
    } else {
      return '/assets/img/logo/LOGO-CR.svg';
    }
  }
}
